import { actionTypes } from "./actions";

const initialState = {
  data: [],
  ezdEdit: {},
  ezdBranchEdit: {
    BranchCode: "",
    BranchDescription: "",
    BranchStatus: "A",
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_EZD_INFO:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_FILTERED_EZD:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_EZD_BY_ID:
      return {
        ...state,
        ezdEdit: payload,
      };

    case actionTypes.SET_BRANCH_BY_ID:
      return {
        ...state,
        ezdBranchEdit: payload,
      };

    case actionTypes.EDIT_FORM_CHANGE:
      return {
        ...state,

        ezdBranchEdit: {
          ...state.ezdBranchEdit,
          [payload.name]: payload.value,
        },
      };

    default:
      return {
        ...state,
      };
  }
};
